// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CookieBanner_wrapper__E7mCk","link":"CookieBanner_link__b_E_U"};